//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { toApp,appFallback,appCancelFallback } from '@/utils/appBridge'
import bridgeApi from "sy-bridge";

  export default {
    data() {
      return {
        interceptLayer:false, //放弃保障弹窗显示隐藏
        position:[
            'top:0.1rem;left:2.725rem;font-size:0.6rem;',
            'top:0.2rem;right:1.175rem;font-size:0.6rem;',
            'top:1.85rem;left:0.25rem;font-size:0.7rem;',
            'top:1.7rem;right:0.5rem;font-size:0.6rem;',
            'top:2.45rem;left:3.925rem;font-size:0.6rem;',
            'top:2.6rem;left:7.625rem;font-size:0.6rem;',
        ],
      }
    },
    props: {
      allData:{
        type: Object,
        default: ()=>{
          return  {}
        }
      },
      scheme:{
        type: Object,
        default: ()=>{
          return  {}
        }
      }
    },
    watch: {
      interceptLayer(newValue, oldValue) {
        if(newValue){
          this.STATISTICS_CONFIG.insur_insurinfoinput_CloseMessageBox_click({"ex":{scheme:this.scheme.schemeName }});
        }
      }
    },
    created () {

    },
    beforeRouteEnter(to, from, next){
      // 条款页返回取消监听
      if(form.path==='/iframePage'){
        appCancelFallback()
      }
      next()
    },
    mounted () {
      // 隐私协议弹窗展示时不监听app回退事件
      this.$nextTick(()=>{
        const plicyKey=localStorage.getItem('insurance-mobile_privacy_plicy_show')
        if(!(plicyKey == null || typeof plicyKey == undefined || plicyKey === 'undefined')){
          appFallback(this.show)
        }
      })
    },
    computed: {
      list(){
        return  [ `仅需支付${this.price}`,`可获得<span class="blue">${this.insuranceBenefit}元</span>保险金`,'由PICC中国人民保险承保']
      },
      // 保险金
      insuranceBenefit() {
        const duties = this.scheme.duties
        if( !duties || !duties.length){
          return null
        }
        const maxPrice = duties.reduce((max,item) =>{
          return parseFloat(max.dutyCoverage) > parseFloat(item.dutyCoverage)? max : item
        })
        // console.log('maxPrice--', maxPrice.dutyCoverage)
        return maxPrice.dutyCoverage
      },
      // 价格
      price(){
        if(this.scheme.selectedLabel == '免费领'){
          return `<span class="blue">${this.scheme.commodityPrice}元</span>`
        }else{
          return `${this.scheme.commodityPrice}元<span class="blue"> ≈ ${this.about}</span>`
        }
      },
      // 
      about(){
        // 0 < y ≤ 10：1袋薯片的钱
        // 10 < y ≤ 20：1杯奶茶的钱
        // 20 < y ≤ 30：1碗米线的钱
        // 30 < y ≤ 40：1份汉堡的钱
        // 40 < y ≤ 50：1场电影的钱
        // y > 50：1次美甲的钱
        const commodityPrice = parseFloat(this.scheme.commodityPrice)
        if(0 < commodityPrice && commodityPrice <= 10){
          return '1袋薯片的钱'
        }else if(10 < commodityPrice && commodityPrice <= 20){
          return '1杯奶茶的钱'
        }else if(20 < commodityPrice && commodityPrice <= 30){
          return '1碗米线的钱'
        }else if(30 < commodityPrice && commodityPrice <= 40){
          return '1份汉堡的钱'
        }else if(40 < commodityPrice && commodityPrice <= 50){
          return '1场电影的钱'
        }else{
          return '1次美甲的钱'
        }
      }
    },
    methods: {
      btnClick() {
        this.STATISTICS_CONFIG.insur_insurinfoinput_CloseMessageBox_submit_click({"ex":{scheme:this.scheme.schemeName }});
        this.$emit('btnClick')
        this.interceptLayer = false
      },
      close(){
        this.interceptLayer = false;
        this.STATISTICS_CONFIG.insur_insurinfoinput_CloseMessageBox_close_click({"ex":{scheme:this.scheme.schemeName }});
        toApp("closeWindow",{});
      },
      show(){
         this.interceptLayer = true
      }
    },
  }
